export var isMobileUserAgent = function isMobileUserAgent(userAgent) {
  return /Android|iPhone/gi.test(userAgent);
};